import { render, staticRenderFns } from "./app-scene.vue?vue&type=template&id=174685f4&"
import script from "./app-scene.vue?vue&type=script&lang=js&"
export * from "./app-scene.vue?vue&type=script&lang=js&"
import style0 from "../styles/app-scene.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports